import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_11'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
